import React, { useCallback } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment, OutlinedInput, debounce } from '@mui/material';

interface IOutlinedInputFieldProps {
  value?: string;
  defaultValue?: boolean;
  onChangeCallback: (value: string) => void;
  placeholder?: string;
  height?: string;
  width?: string;
  borderRadius?: string;
  fontSize?: string;
  fontWeight?: string;
  color?: string;
  startAdornmentVisible?: boolean;
}
const OutlinedInputComponent = ({
  onChangeCallback,
  placeholder,
  height,
  width,
  borderRadius,
  fontSize,
  fontWeight,
  color,
  startAdornmentVisible = true
}: IOutlinedInputFieldProps): JSX.Element => {
  const [searchString, setSearchString] = React.useState<string>('');

  const handleSearchCallback = useCallback(
    debounce((values) => {
      onChangeCallback(values);
    }, 500),
    []
  );

  return (
    <OutlinedInput
      value={searchString}
      onChange={(event) => {
        if (startAdornmentVisible) {
          setSearchString(event.target.value);
          handleSearchCallback(event.target.value);
        } else {
          const onlyNumbers = event.target.value.replace(/[^0-9]/g, '');
          setSearchString(onlyNumbers);
          handleSearchCallback(onlyNumbers);
        }
      }}
      placeholder={placeholder}
      sx={{
        height: { height },
        width: { width },
        borderRadius: { borderRadius },
        '& .MuiOutlinedInput-input::placeholder': {
          fontSize: { fontSize },
          fontWeight: { fontWeight },
          color: { color },
          opacity: 1
        }
      }}
      startAdornment={
        <InputAdornment position="start">
          {startAdornmentVisible && <SearchIcon />}
        </InputAdornment>
      }
      inputProps={{
        inputMode: 'numeric',
        pattern: '[0-9]*'
      }}
    />
  );
};

export default OutlinedInputComponent;
